"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CarSideOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var CarSideOutlineSVG = function CarSideOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M28 12h-4l-3.42-5a2 2 0 00-1.74-1H6.32a2 2 0 00-1.84 1.21l-2.26 4.36a2.08 2.08 0 00-.22.92V20a2 2 0 002 2 4 4 0 008 0h8a4 4 0 008 0 2 2 0 002-2v-6a2 2 0 00-2-2zM14 8h4.84l2.73 4H14zM6.32 8H12v4H4.25zM8 24a2 2 0 112-2 2 2 0 01-2 2zm16 0a2 2 0 112-2 2 2 0 01-2 2zm4-4h-.54a4 4 0 00-6.92 0h-9.08a4 4 0 00-6.92 0H4v-6h24z"
  }));
};
exports.CarSideOutlineSVG = CarSideOutlineSVG;
CarSideOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CarSideOutlineSVG);
exports.default = _default;